<app-dialog [dialogWithInput]="dialog">
    <app-create-update-default
        #createUpdateDefaultComponent
        (entityLoaded)="entityLoaded($event)"
        (entitySaved)="entitySaved($event)"
        [buildPayload]="buildPayload"
        [formGroup]="formGroup"
        [id]="dialog.input.id"
        [findOneService]="findOneService"
        [inDialog]="true"
        [hideSaveButton]="true"
        [service]="service">
        <ng-template template-content>
            <div class="row">
                <div class="col-12">
                    <app-card-v2 title="Informations générales">
                        <div class="row">
                            <app-form-field label="Catégorie" required="true" sizeLg="4" sizeXl="2">
                                <app-lov-value-select-filter style="width: 100%" [parentFormGroup]="formGroup"
                                                             [filterLovValueProcessor]="filterMedicalRecordProblemType"
                                                             [hideChildren]="true"
                                                             [sort]="lovValueSort" lovListName="MEDICAL_RECORD_PROBLEM_TYPE"
                                                             parentFormControlName="categoryValue">
                                </app-lov-value-select-filter>
                            </app-form-field>
                            <app-form-field label="Sous-catégorie" required="true" sizeLg="4" sizeXl="2">
                                <app-lov-value-select-filter style="width: 100%" [parentFormGroup]="formGroup"
                                                             [filterLovValueProcessor]="filterMedicalRecordProblemType"
                                                             [excludeParent]="true"
                                                             [parentValue]="formGroup.get('categoryValue').value"
                                                             [sort]="lovValueSort" lovListName="MEDICAL_RECORD_PROBLEM_TYPE"
                                                             parentFormControlName="typeValue">
                                </app-lov-value-select-filter>
                            </app-form-field>
                            <app-form-field label="Description" size="12">
                                <app-rich-text-editor [parentFormGroup]="formGroup" [audioTranscriptionConfig]="descriptionAudioTranscription"
                                                      parentFormControlName="description"></app-rich-text-editor>
                            </app-form-field>
                        </div>
                        <div class="row">
                            <app-form-field label="Date de début" size="12" sizeLg="9" sizeXl="9" required = "true">
                                <app-custom-date-input #from [parentFormGroup]="formGroup.controls.from"
                                                       style="width: 100%;"></app-custom-date-input>
                            </app-form-field>
                            <app-form-field label="Le problème est toujours présent" size="12" sizeLg="3"
                                            sizeXl="3">
                                <app-checkbox-input [parentFormGroup]="formGroup"
                                                    parentFormControlName="stillHere"
                                                    (changeEvent)="synchronizeStillHereControl()"></app-checkbox-input>
                            </app-form-field>
                        </div>
                        <div class="row" *ngIf="formGroup.get('to')">
                            <app-form-field label="Date de fin" size="6" sizeLg="6" sizeXl="4">
                                <app-custom-date-input #to
                                                       [parentFormGroup]="formGroup.controls.to"
                                                       [initialTypeValue]="toInitialTypeValue"
                                                       [initialDate]="toInitialDate"
                                                       style="width: 100%;"></app-custom-date-input>
                            </app-form-field>
                        </div>
                    </app-card-v2>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <app-card-v2 title="Localisation et traitement">
                        <div class="row">
                            <app-form-field label="Localisation" [size]="12">
                                <app-lov-value-chips-autocomplete
                                        lovListName="MEDICAL_RECORD_PAIN_WHERE"
                                        [parentFormGroup]="formGroup"
                                        parentFormControlName="locations">
                                </app-lov-value-chips-autocomplete>
                            </app-form-field>

                            <app-form-field label="Quand?" [size]="12">
                                <app-lov-value-chips-autocomplete
                                        lovListName="MEDICAL_RECORD_PAIN_WHEN"
                                        [parentFormGroup]="formGroup"
                                        parentFormControlName="whens">
                                </app-lov-value-chips-autocomplete>
                            </app-form-field>
                            <app-form-field size="12" label="Praticiens en charge">
                                <app-form-array-input
                                        [buildNewItemForm]="newItemFormGroup"
                                        [parentFormGroup]="formGroup"
                                        addItemLabel="Ajouter un praticien"
                                        parentFormControlName="involvedPartners">
                                    <ng-template let-itemFormGroup='itemFormGroup' template-content>
                                        <div class="row">
                                            <app-form-field size="12">
                                                <app-partner-search-with-create-ability
                                                        [parentFormGroup]="itemFormGroup"
                                                        [typeValue]="PRACTITIONER"
                                                        parentFormControlName="partnerId"
                                                        placeHolder="Chercher un praticien"></app-partner-search-with-create-ability>
                                            </app-form-field>
                                        </div>
                                    </ng-template>
                                </app-form-array-input>
                            </app-form-field>
                            <app-form-field size="12" label="Traitement">
                                <app-rich-text-editor [parentFormGroup]="formGroup" [audioTranscriptionConfig]="treatmentAudioTranscription"
                                                      parentFormControlName="treatment"></app-rich-text-editor>
                            </app-form-field>
                        </div>
                    </app-card-v2>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <app-card-v2 title="Commentaire">
                        <div class="row">
                            <app-form-field size="12">
                                <app-rich-text-editor [parentFormGroup]="formGroup"
                                                      parentFormControlName="comment"></app-rich-text-editor>
                            </app-form-field>
                        </div>
                    </app-card-v2>
                </div>
            </div>
        </ng-template>
    </app-create-update-default>
    <ng-container dialog-actions>
        <app-loading [loading]="createUpdateDefaultComponent.saveLoading" [showText]="false"></app-loading>
        <app-button (click)="executeSave()" [disabled]="!formGroup.valid" fill="solid" color="primary"
                    iconName="check" label="Enregistrer" *ngIf="!createUpdateDefaultComponent.saveLoading &&
                !createUpdateDefaultComponent.loading && !createUpdateDefaultComponent.findOneError"></app-button>
    </ng-container>
</app-dialog>
